import { IBoard, IUserActiveItem, IUserDepricated } from "@mctypes/global.types";
import { Box, Text } from "@mantine/core";
import React, { useState } from "react";
import { useCopyToClipboard } from "usehooks-ts";
import { STANDARD_COLORS } from "../../app/globalConstants";
import { IMemberWithDomain } from "../../app/routes/admin/members/memberTypes";
import IssueItemModalMantine from "../../app/routes/issuesApp/IssuesTab/IssueItemModal/new/IssueItemModalMantine";
import Avatar from "../Avatar";
import FoldableSectionDeprecated from "../FoldableSection/FoldableSectionDeprecated";
import "./MemberCard.css";

interface IMemberCardProps {
  member: IMemberWithDomain;
  assignedItems?: IUserActiveItem[];
  projectId: string;
  orgTitle?: string;
}
const MemberCardDepricated: React.FC<IMemberCardProps> = ({ member, assignedItems, projectId, orgTitle }) => {
  const [, copy] = useCopyToClipboard();
  const [activeAssignedItem, setActiveAssignedItem] = useState<IUserActiveItem>(null);

  const infoRows = [
    { label: "tlf", value: (member?.user as IUserDepricated)?.phoneNumber ?? "-" },
    { label: "epost", value: (member?.user as IUserDepricated)?.email ?? "-" },
    { label: "disiplin", value: member?.disciplin ?? "-" },
    { label: "domene", value: member?.domain ?? "-" },
  ];
  const roleColors = {
    ADMIN: STANDARD_COLORS.orange,
    PARTNER: STANDARD_COLORS.green,
    INTERNAL: STANDARD_COLORS.grey,
    CLIENT: STANDARD_COLORS.blue,
  };

  return (
    <>
      <div className="memberCard">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ marginRight: "-.5em" }}>
            <Avatar
              id={(member?.user as IUserDepricated)?._id}
              name={(member?.user as IUserDepricated)?.name}
              size="xl"
            />
          </div>
          <Box component="h3" my="0.25rem">
            {(member?.user as IUserDepricated)?.name}
          </Box>{" "}
          {orgTitle && (
            <Text fw={500} mb="xs">
              {orgTitle}
            </Text>
          )}
          <div
            className="memberGroupBadge"
            style={{ color: `${roleColors[member?.group]}`, border: `3px solid ${roleColors[member?.group]}` }}
          >
            {member?.group}
          </div>
        </div>
        <div className="infoContainer">
          {infoRows.map((row, i) => (
            <div key={i} className="rowContainer" style={{ display: "flex", fontSize: "1.1em", alignItems: "center" }}>
              <div className="rowLabel">{row.label}:</div>
              <div className="rowValue">{row.value}</div>
              <button className="addIcon" onClick={() => copy(row.value)}>
                <i className="fa fa-files-o"></i>
              </button>
            </div>
          ))}
        </div>
        <div className="foldableContainer">
          {assignedItems != null && (
            <FoldableSectionDeprecated folded={true} headerClick={true}>
              <FoldableSectionDeprecated.Header>
                <div className="section-title" style={{ display: "flex", alignItems: "center" }}>
                  Aktive Oppgaver
                  <div
                    className="textCircle"
                    style={{
                      fontSize: "0.7em",
                      width: "1.7em",
                      height: "1.7em",
                      marginTop: ".2em",
                      marginLeft: "0.5rem",
                    }}
                  >
                    {assignedItems?.length}
                  </div>
                </div>
              </FoldableSectionDeprecated.Header>
              {/* <FoldableSectionDeprecated.Body>
                <div className="tableContainer ag-theme-quartz" style={{ display: "flex", flexDirection: "column", height: "100%", marginBottom: "0.5rem" }}>
                  {assignedItems && assignedItems.length > 0 && (
                    <AgGridReact
                      rowData={assignedItems}
                      columnDefs={createActiveAssignedItemsColumns(setActiveAssignedItem)}
                      domLayout="autoHeight"
                      headerHeight={40}
                      defaultColDef={{
                        sortable: false,
                        filter: false,
                        suppressHeaderMenuButton: true,
                        cellStyle: {
                          whiteSpace: "normal",
                          lineHeight: "1.5",
                          wordBreak: "break-word",
                        },
                        autoHeight: true,
                      }}
                      onGridReady={(e) => {
                        e.api.autoSizeColumns(["id", "name", "dueDate", "status"]);
                      }}
                    />
                  )}
                </div>
              </FoldableSectionDeprecated.Body> */}
            </FoldableSectionDeprecated>
          )}
        </div>
      </div>
      {activeAssignedItem && activeAssignedItem.app === "issues" && (
        <IssueItemModalMantine
          itemId={activeAssignedItem.itemId}
          issueBoardId={(activeAssignedItem.board as IBoard)._id}
          projectId={projectId}
          onClose={() => setActiveAssignedItem(null)}
        />
      )}
    </>
  );
};

export default MemberCardDepricated;
